import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiFormatDatePipe } from './fi-format-date.pipe';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

@NgModule({
    imports: [CommonModule],
    declarations: [FiFormatDatePipe],
    exports: [FiFormatDatePipe],
    providers: [FiFormatDateService],
})
export class FiFormatDateModule {}
